import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "../src/styles/index.scss";
import Routes from "./routes";
import * as serviceWorker from "./serviceWorker";
import ErrorBoundary from "components/blocks/ErrorBoundary/ErrorBoundary";
import { L10n, setCulture, loadCldr, registerLicense } from "@syncfusion/ej2-base";
import { MsalProvider } from "@azure/msal-react";
import { createBrowserHistory } from "history";
import useMsalB2C from "hooks/useMsalB2C";
import "styles/vendors/material-company/compatibility/material.css";
import { GlobalStateProvider } from "components/pages/GeneralManagement/generalManagementState";
import { SignalRContextProvider } from "contexts/SignalRContext";
import { FormStateProvider } from "components/pages/GeneralManagement/ManagementFormStateContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as gregorian from "cldr-data/main/es/ca-gregorian.json";
import * as numbers from "cldr-data/main/es/numbers.json";
import * as numberingSystems from "cldr-data/supplemental/numberingSystems.json";

loadCldr(numberingSystems, gregorian, numbers);
const expLogEnabled =
  import.meta.env.VITE_REACT_APP_EXP_LOG === true ||
  ["1", "true"].includes(
    String(import.meta.env.VITE_REACT_APP_EXP_LOG ?? "")
      .trim()
      .toLowerCase(),
  );

if (import.meta.env.PROD && !expLogEnabled)  {
const solimatAscii = `
    *    .  *       .       *     .       *    .
  .   *         *       .    *         .     *
     .    *   .      *    .        *      .
   _____       __   _                  __     
  / ___/____  / /  (_)___ ___   ____ _/ /_    
  \\__ \\/ __ \\/ /  / / __ \`__ \\ / __ \`/ __/    
 ___/ / /_/ / /  / / / / / / // /_/ / /_      
/____/\\____/_/  /_/_/ /_/ /_/ \\__,_/\\__/      
  .    *      .      *    .         *     .
     *    .       *           .   *     .
  *         .  *        .  *        *      .
`;

  const original = {
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error,
    debug: console.debug,
  };

  // Para cada tipo de salida de consola
  ['log','info','warn','debug'].forEach((method) => {
    let alreadyPrinted = false;
    console[method] = (...args) => {
      if (!alreadyPrinted) {
        original[method](solimatAscii);
        alreadyPrinted = true;
      }
  
    };
  });
}

L10n.load({
  es: {
    "react-dropdowns": {
      actionFailureTemplate: "Se ha producido un error al cargar los datos.",
      noRecordsTemplate: "No se han encontrado coincidencias.",
    },
    grid: {
      EmptyRecord: "No hay resultados registrados.",
      Add: "Añadir",
      Edit: "Editar",
      Delete: "Borrar",
      Update: "Actualizar",
      Cancel: "Cancelar",
      Print: "Imprimir",
      PdfExport: "Exportar a PDF",
      ExcelExport: "Exportar a Excel",
      EditOperationAlert: "Seleccione una fila a editar",
      DeleteOperationAlert: "Seleccione una fila a borrar",
      ConfirmDelete: "Seguro que quiere borrar esta fila?",
      CancelButton: "Cancelar",
    },
    dropdowns: {
      nodata: "No hay resultados.",
      noRecordsTemplate: "No hay resultados.",
      clear: "claro",
      comboArrowBtnAriaLabelExpand: "ampliar el cuadro combinado",
      comboArrowBtnAriaLabelCollapse: "colapsar cuadro combinado",
      dropDownListArrowBtnAriaLabel: "seleccione",
    },
    pager: {
      currentPageInfo: "{0} de {1} páginas",
      totalItemsInfo: "({0} registros)",
      pagerDropDown: "resultados por página",
      All: "Todos",
      pagerAllDropDown: "resultados",
    },
    datepicker: {
      placeholder: "Por favor seleccione una fecha",
      today: "Hoy",
    },
  },
});

// Licencia de Syncfusion desde las variables de CRA
registerLicense(import.meta.env.VITE_REACT_APP_SYNCFUSION_LICENSE);

setCulture("es");

const App = () => {
  const history = createBrowserHistory();
  const { msalInstance } = useMsalB2C();
  useEffect(() => {}, [history]);

  return (
    <MsalProvider instance={msalInstance}>
      <SignalRContextProvider>
        <GlobalStateProvider>
          <FormStateProvider>
            <Routes />
            <ToastContainer />
          </FormStateProvider>
        </GlobalStateProvider>
      </SignalRContextProvider>
    </MsalProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// CRA service worker
serviceWorker.unregister();
